import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69d91d38a749570014996a2b/blv/src/app/your-reset-practice-home/components/PracticeHomeContent.tsx");
